/* ============
 * State of the system module
 * ============
 *
 * The initial state of the system module.
 */

export default {
  // 系统信息
  info: {},
};
